import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { Button, Form, Table } from "react-bootstrap";
import { FaLock, FaLockOpen, FaPlus, FaRegTrashAlt, FaTrashAlt } from "react-icons/fa";
import { NoDataFoundTable } from "../../../Hooks/NoDataFoundTable";
import UseToggle from "../../../Hooks/UseToggle";
import Pagination from "../../../Hooks/Pagination";
import AddSitePilotAddons from "./AddSitePilotAddons";
import Swal from "sweetalert2";
import DeletedSitePilotAddons from "./DeletedSitePilotAddons";
import UpdateSitePilotAddons from "./UpdateSitePilotAddons";
import SitePilotAddonsPreview from "./SitePilotAddonsPreview";
import Moment from "react-moment";
import { addonsServices } from "../../../APIServices/SitePilotManagement/addonsServices";
import SitePilotAddonsActivity from "./SitePilotAddonsActivity";

const SitePilotAddons = () => {
  const toggles = UseToggle();
  
  const [searchData, setSearchData] = useState("");
  const [sitePilotAddonsList, setSitePilotAddonsList] = useState([]);
  const [sitePilotAddonsCount, setSitePilotAddonsCount] = useState(0);
  const [singleSitePilotAddons, setSingleSitePilotAddons] = useState("");
  
  const [deletedSitePilotAddons, setDeletedSitePilotAddons] = useState([]);
  const [deletedSitePilotAddonsCount, setDeletedSitePilotAddonsCount] = useState(0);
  
  const [sitePilotAddonsdata, setSitePilotAddonsdata] = useState("");
  const [openPreview, setOpenPreview] = useState(false);
  const [openModule, setOpenModule] = useState("preview");
  
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(sitePilotAddonsCount / itemsPerPage);
  
  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);
  
  const tabs = [
    { key: "preview", label: "Preview" },
    ...(!singleSitePilotAddons?.lockStatus
      ? [{ key: "sitePilotAddonsEditor", label: "Addons Editor" }]
      : []),
    { key: "activity", label: "Activity" },
  ];
  
  const getSitePilotAddonsList = async () => {
    let data = await addonsServices.getSitePilotAddonList(
      "all",
      searchData,
      pageNumber,
      itemsPerPage
    );
    setSitePilotAddonsList(data?.data || []);
    setSitePilotAddonsCount(data?.count || 0);
  };

  const getDeletedSitePilotAddonsList = async () => {
    let data = await addonsServices.getSitePilotAddonList(
      "deleted",
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedSitePilotAddons(data?.data || []);
    setDeletedSitePilotAddonsCount(data?.count || 0);
  };

  const softDeleteRestoreSitePilotAddons = async (formId, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} blog post?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const userData = { formId, type };
      const data = await addonsServices.softDeleteRestoreSitePilotAddon(userData);
      if (data?.statusCode === 200) {
        getSitePilotAddonsList();
        getDeletedSitePilotAddonsList();
      }
    });
  };

  const updatedLockSitePilotAddons = async (addonId, lockStatus) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${lockStatus ? "lock" : "unlock"} Addons?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const userData = { addonId, lockType: true, lockStatus };
      const data = await addonsServices.updatedSitePilotAddon(userData);
      if (data?.statusCode === 200) getSitePilotAddonsList();
    });
  };

  useEffect(() => {
    getSitePilotAddonsList();
  }, [searchData, pageNumber, itemsPerPage]);

  const getSingleSitePilotAddons = async () => {
    let data = await addonsServices.getSingleSitePilotAddon(sitePilotAddonsdata?.addonId);
    setSingleSitePilotAddons(data?.data || "");
  };

  useEffect(() => {
    if (sitePilotAddonsdata) {
      getSingleSitePilotAddons()
    }
  }, [sitePilotAddonsdata]);
  
  return (
    <>
    <div style={{ background: "#eee" }}>
      <div className="p-2 d-flex gap-2">
        <div className={`meta-table overflow-auto`} style={{ height: "calc(100vh - 71px)", flex: openPreview ? ".5 0 " : ""}}>
          <div className="hstack gap-2 pb-2 bg-white">
            <Button
              size="sm"
              variant="outline-primary"
              className="hstack gap-2 text-nowrap rounded-1 border"
              style={{ fontSize: 13 }}
              onClick={toggles.setToggle}
            >
              <FaPlus /> {!openPreview && "Add New"}
            </Button>
            <div className="search-box position-relative w-100">
              <FiSearch />
              <Form.Control
                type="search"
                className="w-100 rounded-1"
                style={{ fontSize: 13 }}
                placeholder="Search..."
                value={searchData}
                onChange={(e) => setSearchData(e.target.value)}
              />
            </div>
            {deletedSitePilotAddonsCount > 0 && (
              <Button
                variant="outline-danger"
                className="hstack gap-2 text-nowrap rounded-1 border"
                style={{ fontSize: 13 }}
                onClick={toggles.setToggle2}
              >
                <FaRegTrashAlt /> {!openPreview && "Deleted History"}
              </Button>
            )}
          </div>
          <div className="overflow-auto" style={{ height: "calc(100vh - 122px)"}}>
            {sitePilotAddonsCount === 0 ? (
              <NoDataFoundTable MSG="No Addons." />
            ) : (
              <>
                <Table hover responsive className="">
                  <thead className="position-sticky" style={{ top: -1 }}>
                    <tr>
                      <th style={{ width: 45 }} className="text-center">
                        Sr.
                      </th>
                      <th style={{ width: !openPreview && "30%" }}>Title</th>
                      {!openPreview && (
                        <>
                          <th>Hourly Price</th>
                          <th>Monthly Price</th>
                          <th>Yearly Price</th>
                          <th>Updated By</th>
                          <th>Update Date | Time</th>
                          <th>Status</th>
                          <th className="text-center">Lock</th>
                          <th className="text-center" style={{ width: 80 }}>
                            Actions
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {sitePilotAddonsList?.map((item, index) => (
                      <tr
                        key={index}
                        className={
                          sitePilotAddonsdata?.addonId === item.addonId ? "selectedRow CP" : "CP"
                        }
                        onClick={() => {
                          setOpenPreview(true);
                          setSitePilotAddonsdata(item);
                        }}
                      >
                        <td className="text-center">{startIndex + index + 1}</td>
                        <td className="text-truncate text-wrap" style={{ maxWidth: 100 }}>
                          <strong>{item.title}</strong>
                          <div className="sub-text">
                            {item.shortDescription}
                          </div>
                        </td>
                        {!openPreview && (
                          <>
                            <td>{item.updatedByName}</td>
                            <td>{item.hourlyPrice}</td>
                            <td>{item.monthlyPrice}</td>
                            <td>{item.yearlyPrice}</td>
                            <td><Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
                              {item?.updatedAt}
                            </Moment></td>
                            <td className={`text-capitalize fw-bold ${item.status === "active" ? "text-success" : item.status === "inactive" ? "text-danger" : "text-muted"}`}>{item.status}</td>
                            <td
                              className="text-center CP"
                              title="Lock Status"
                              onClick={(e) => {
                                e.stopPropagation();
                                updatedLockSitePilotAddons(item.addonId, !item.lockStatus);
                              }}
                            >
                              {item.lockStatus ? (
                                <FaLock className="text-success" />
                              ) : (
                                <FaLockOpen className="text-danger" />
                              )}
                            </td>
                            <td className="text-center actions">
                              <FaTrashAlt
                                title="Delete"
                                onClick={(e) => {e.stopPropagation();
                                if (!item.lockStatus) {
                                    softDeleteRestoreSitePilotAddons(
                                      item.addonId,
                                      "delete"
                                    );
                                  }} }
                                className={`icon danger CP ${item.lockStatus ? "disabled" : ""}`}
                              />
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={sitePilotAddonsCount?.totalItems}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {openPreview && (
          <div className="meta-preview" style={{ flex: "1.5 0" }}>
            <div className="preview-header hstack justify-content-between">
              <div className="hstack gap-2">
                {tabs.map((tab) => (
                  <Button
                    key={tab.key}
                    size="sm"
                    style={{ fontSize: 13 }}
                    variant={
                      openModule === tab.key ? "primary" : "outline-primary"
                    }
                    onClick={() => setOpenModule(tab.key)}
                  >
                    {tab.label}
                  </Button>
                ))}
              </div>
              <Button
                size="sm"
                style={{ fontSize: 13 }}
                variant="outline-danger"
                onClick={() => setOpenPreview(false)}
              >
                Close
              </Button>
            </div>
            {openModule === "preview" && (
              <div
                className="overflow-auto"
                style={{ height: "calc(100vh - 123px)" }}
              >
              <div className="w-50 m-auto">
                <SitePilotAddonsPreview singleSitePilotAddons={singleSitePilotAddons}/>
              </div>
              </div>
            )}
            {openModule === "sitePilotAddonsEditor" && (
              <UpdateSitePilotAddons
                singleSitePilotAddons={singleSitePilotAddons}
                getSitePilotAddonsList={getSitePilotAddonsList}
                getSingleSitePilotAddons={getSingleSitePilotAddons}
              />
            )}
            {openModule === "activity" && <SitePilotAddonsActivity />}
          </div>
        )}
      </div>
    </div>
    <AddSitePilotAddons
      Show={!toggles?.toggle}
      Hide={toggles?.setToggle}
      Title={`Add New Addons`}
      getSitePilotAddonsList={getSitePilotAddonsList}
      />

      <DeletedSitePilotAddons
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title={`Restore Mail Addonss`}
        deletedSitePilotAddons={deletedSitePilotAddons}
        softDeleteRestoreSitePilotAddons={softDeleteRestoreSitePilotAddons}
        deletedSitePilotAddonsCount={deletedSitePilotAddonsCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        getDeletedSitePilotAddonsList={getDeletedSitePilotAddonsList}
      />
    </>
  );
};

export default SitePilotAddons;
